import { render, staticRenderFns } from "./GatGridItem.vue?vue&type=template&id=a2d62a6a&scoped=true"
import script from "./GatGridItem.vue?vue&type=script&lang=js"
export * from "./GatGridItem.vue?vue&type=script&lang=js"
import style0 from "./GatGridItem.vue?vue&type=style&index=0&id=a2d62a6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2d62a6a",
  null
  
)

export default component.exports